import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getWorkflowTemplateRestoreVersionDetails } from "services/workflows/workflowTemplateRestoreVersionRepository";

export interface WorkflowTemplateRestoreVersionDetails {
    profile: string;
    editorVersion: string;
    workflowUuid: string;
    versionId: string;
}

export interface WorkflowRestoreVersionState {
    workflowTemplateRestoreVersion: WorkflowTemplateRestoreVersionDetails | null;
}

const INITIAL_STATE: WorkflowRestoreVersionState = {
    workflowTemplateRestoreVersion: getWorkflowTemplateRestoreVersionDetails(),
};

const WORKFLOW_TEMPLATES_SLICE = createSlice({
    name: "workflowTemplatesStore",
    initialState: INITIAL_STATE,
    reducers: {
        setRestoreWorkflowTemplateVersion(state, action: PayloadAction<WorkflowTemplateRestoreVersionDetails>) {
            state.workflowTemplateRestoreVersion = action.payload;
        },
        removeRestoreWorkflowTemplateVersion(state) {
            state.workflowTemplateRestoreVersion = null;
        },
    },
});

export const { setRestoreWorkflowTemplateVersion, removeRestoreWorkflowTemplateVersion } =
    WORKFLOW_TEMPLATES_SLICE.actions;

export default WORKFLOW_TEMPLATES_SLICE.reducer;
